import { create } from "zustand";
import { SupervisorQueuesActions, SupervisorQueuesState } from "./types";
import { SupervisedQueue } from "@/repository/models";

export const useSupervisorQueuesStore = create<
	SupervisorQueuesState & SupervisorQueuesActions
>((set) => ({
	queues: [],
	setQueues: (queues: SupervisedQueue[]) => set({ queues: queues }),
	remove: (id: string) =>
		set((state: SupervisorQueuesState) => ({
			queues: state.queues.filter((x) => x.id !== id),
		})),
	update: (queue: SupervisedQueue) =>
		set((state: SupervisorQueuesState) => ({
			queues: state.queues.map((q) =>
				q.id === queue.id ? { ...queue, type: q.type } : q
			),
		})),
}));
